import React from 'react';
import { Loader2 } from 'lucide-react';
import { TableCell, TableRow } from '@/components/ui/table';

/**
 * Renders the body for a list-style table with a single, declarative state.
 * Avoids nested ternaries inline in pages.
 */
export default function TableStateBody({ loading, isEmpty, colSpan, emptyText = 'No records found', children }) {
  if (loading) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} className="text-center py-8 text-slate-500">
          <Loader2 className="h-4 w-4 animate-spin inline mr-2" /> Loading...
        </TableCell>
      </TableRow>
    );
  }
  if (isEmpty) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} className="text-center py-8 text-slate-500">
          {emptyText}
        </TableCell>
      </TableRow>
    );
  }
  return <>{children}</>;
}
